export default "__VITE_ASSET__BWgzLycw__"